module.exports = __webpack_public_path__ + "static/media/menu.347ef035.jpg";